// Module
var code = `<div class="form-column">
  <form-section form-title="'Advanced'">
    <form-section-field field-title="'On manual rollover pre-fill parameters from existing term deposit'">
      <select
        ng-model="\$ctrl.deposit.prefillManualRollover"
        boolean-options
        required>
      </select>
    </form-section-field>
    <div class="alert alert-info" ng-if="\$ctrl.deposit.useOriginalTermOnRollover">
      Holiday settings will still apply if maturity date is a non-working day.
    </div>
    <form-section-field field-title="'On rollover, always use original term'">
      <select
        ng-model="\$ctrl.deposit.useOriginalTermOnRollover"
        boolean-options
        required>
      </select>
    </form-section-field>
    <form-section-field field-title="'On calculating interest crediting date, always use original reference date'"
                        ng-if="!\$ctrl.deposit.creditingStrategies.includes('NOT_ALLOWED')"
                        class="form-section-field-input">
      <select
        ng-model="\$ctrl.deposit.calculateCreditingDateBasedOnReferenceDate"
        boolean-options
        required>
      </select>
      <help
        title="If yes, system will calculate next execution date based on certification/activation date otherwise, will use last execution date.">
      </help>
    </form-section-field>
    <form-section-field field-title="'Custom fields:'">
      <custom-field-definition-multiselect
        definition-ids="\$ctrl.deposit.customFieldDefinitionIds"
        group="'DEPOSIT'">
      </custom-field-definition-multiselect>
    </form-section-field>

  </form-section>

  <form-section form-title="'Holidays'">
    <form-section-field field-title="'Honor holidays?'">
      <select
        ng-model="\$ctrl.deposit.honorHolidays"
        ng-change="\$ctrl.onHonorHolidaysChange()"
        boolean-options
        required>
      </select>
    </form-section-field>
    <form-section-field field-title="'When maturity date falls on a holiday (during creation)'"
                        ng-if="\$ctrl.deposit.honorHolidays">
      <select ng-model="\$ctrl.deposit.maturityAdjustmentStrategy.holidayAdjustmentStrategy"
              ng-options="a.value as a.label for a in \$ctrl.onCreateAdjustmentStrategies"
              required></select>
    </form-section-field>
    <form-section-field field-title="'When maturity date falls on a non-working saturday (during creation)'"
                        ng-if="\$ctrl.deposit.honorHolidays">
      <select ng-model="\$ctrl.deposit.maturityAdjustmentStrategy.saturdayAdjustmentStrategy"
              ng-options="a.value as a.label for a in \$ctrl.onCreateAdjustmentStrategies"
              required></select>
    </form-section-field>
    <form-section-field field-title="'When maturity date falls on a non-working sunday (during creation)'"
                        ng-if="\$ctrl.deposit.honorHolidays">
      <select ng-model="\$ctrl.deposit.maturityAdjustmentStrategy.sundayAdjustmentStrategy"
              ng-options="a.value as a.label for a in \$ctrl.onCreateAdjustmentStrategies"
              required></select>
    </form-section-field>
  </form-section>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/term-deposit/section/advanced/term-deposit-advanced.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;